import { currentUserKey } from '@/shared/msw-constants';
import * as decode from 'jwt-decode';

// tslint:disable-next-line:no-unused
function checkIfTokenExpired() {
  const currentUser = localStorage.getItem(currentUserKey);
  const token =  currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
  if (token) {
    const decodedToken : any = decode(token);
      // return decodedToken.exp ? true  : false;
    return decodedToken.exp ? Math.floor(+new Date() / 1000) > decodedToken.exp  : false;
  }
  return false;
}
function getTokenExpirationTime() {
  const currentUser = localStorage.getItem(currentUserKey);
  const token =  currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
  if (token) {
    const decodedToken : any = decode(token);
    return decodedToken.exp ? decodedToken.exp : false;
  }
  return false;
}
function getRefreshToken() {
  const currentUser = localStorage.getItem(currentUserKey);
  return currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).refreshToken : '';
}

export const tokenExpirationService = {
  checkIfTokenExpired,
  getRefreshToken,
  getTokenExpirationTime,
};
